export const formatDates = (dates) => { // To YYYY-MM-DD

    if ( !dates?.sinceDate || !dates?.untilDate ) return {sinceDate: "", untilDate: ""};

    const sinceDate = (dates?.sinceDate.split('-')?.map((part, i) => {
        if ( i === 0 || part.length === 2 ) return part 
        else if ( part.length === 1 ) return "0"+part; 
    })).join('-');

    const untilDate = (dates?.untilDate.split('-')?.map((part, i) => {
        if ( i === 0 || part.length === 2 ) return part 
        else if ( part.length === 1 ) return "0"+part; 
    })).join('-');

    return {sinceDate, untilDate};
}


export const calculateDaysBetweenDates = (dates) => {  // From YYYY-MM-DD
    const startDate = new Date(dates?.sinceDate);
    const endDate = new Date(dates?.untilDate);
    
    // Calculate the time difference in milliseconds
    const timeDiff = endDate - startDate;
    
    // Convert milliseconds to days
    const daysDiff = timeDiff / (1000 * 60 * 60 * 24);
    
    // Round down the result to get whole days
    return Math.floor(daysDiff);
}